import * as React from 'react';
import { useState } from 'react';

import { compose } from 'recompose';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import connectToRouter from 'js/lib/connectToRouter';

import { DownloadIcon } from '@coursera/cds-icons';
import { Button as TrackedButton } from '@coursera/event-pulse/react';

import { UsageReportDrawer } from 'bundles/enterprise-admin-drawers/components/UsageReportDrawer';
import { disableNonScalableOrgActionsOrgs } from 'bundles/enterprise-admin-home/constants';
import type { ProgramNameList } from 'bundles/enterprise-admin-home/utils/ProgramSummaryUtils';
import { useEnterpriseAdminTrackingData } from 'bundles/enterprise-admin-hooks/hooks/useEnterpriseAdminTrackingData';
import EnterprisePermissionsRequired from 'bundles/enterprise-admin-roles/components/EnterprisePermissionsRequired';
import TrackedDivV2 from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/enterprise-admin-home';

type PropsFromCaller = {
  programNameList: ProgramNameList;
  thirdPartyOrganization: { id: string; slug: string };
};

type PropsFromRouter = {
  router: InjectedRouter;
};

type Props = PropsFromCaller & PropsFromRouter;

const LearnerEngagementHeaderActions: React.FC<Props> = (props) => {
  const [isUsageReportOpen, setIsUsageReportOpen] = useState<boolean>(false);
  const { thirdPartyOrganization, programNameList } = props;
  const enterpriseAdminTrackingData = useEnterpriseAdminTrackingData();

  if (disableNonScalableOrgActionsOrgs.includes(thirdPartyOrganization.id)) {
    return <div />;
  }

  return (
    <div>
      <EnterprisePermissionsRequired domain="ANY_PROGRAM" subdomain="USAGE_REPORT" verb="EXPORT">
        <TrackedDivV2
          trackingName="email_report"
          trackingData={{ thirdPartyOrganizationId: thirdPartyOrganization.id }}
        >
          <TrackedButton
            onClick={() => setIsUsageReportOpen(true)}
            variant="ghost"
            icon={<DownloadIcon size="medium" color="interactive" />}
            iconPosition="before"
            trackingData={{
              button: { name: 'enterprise_admin_email_usage_report' },
              pageSection: {
                sectionName: 'learner_engagement',
              },
              ...enterpriseAdminTrackingData,
            }}
          >
            {_t('Email usage report')}
          </TrackedButton>
        </TrackedDivV2>
      </EnterprisePermissionsRequired>
      <UsageReportDrawer
        organizationId={thirdPartyOrganization.id}
        programs={programNameList}
        onClose={() => setIsUsageReportOpen(false)}
        isOpen={isUsageReportOpen}
      />
    </div>
  );
};

export default compose<Props, PropsFromCaller>(connectToRouter((router) => ({ router })))(
  LearnerEngagementHeaderActions
);
